<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <!-- Header -->
      <div class="row justify-between items-center">
  <!-- Başlık -->
  <div class="col-auto" v-html="vars.titleHtml"></div>

 
  <div class="col-auto flex items-center space-x-4">
    <nuxt-link
      v-for="button in buttons"
      :key="`ourguide-button-${button.button_label}`"
      :to="button.button_link"
      :external="true"
      :class="`n-${button.button_type}`"
    >
      {{ button.label }}
    </nuxt-link>
  </div>
</div>

      <!-- Slider -->
      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
        data-gap="30"
        data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(card, index) in cards"
            :key="index"
          >
          <div class="imageCard -type-2">
  <div class="imageCard__image relative ratio ratio-45:55">
    <img :src="card.photo" alt="image" class="img-ratio" />
  </div>
  <h5 class="imageCard__title">{{ card.title }}</h5>
  <div class="mt-4">
    <nuxt-link
      v-for="button in buttons"
      :key="`ourguide-button-${button.label}`"
      :to="button.link"
      :external="true"
      :class="`n-${button.type}`"
    >
      {{ button.label }}
    </nuxt-link>
  </div>
</div>

          </div>
        </div>

        <!-- Navigation Arrows -->
        <div class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center">
          <button class="sliderNav -prev js-prev n-link">
            <i class="icon-left-arrow"></i>
          </button>
          <button class="sliderNav -next ml-20 js-next n-link">
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'OurGuide',
  mixins: [ComponentMixin],

  computed: {
   
    // Cards array expects { photo: string, title: string }
    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    }
  },
});
</script>
